import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { PayWhen } from 'hb-react/shared/apps/Events/constants/registrationSteps';

const PayButtons = ({
  breakpoint,
  event,
  isFixed,
  isSubmitting,
  payWhen,
  submitForm,
}) => (
  <WrapperButtonPay $isFixed={isFixed} $breakpoint={breakpoint}>
    {event.can_pay_later && (
      <Button
        variant="secondary"
        mr={{ _: 0, m: 2 }}
        pl={0}
        onClick={() => {
          payWhen.current = PayWhen.PAY_LATER;
          submitForm();
        }}
        isLoading={payWhen.current === PayWhen.PAY_LATER && isSubmitting}
      >
        {s__(`NetworkEvents|Pay later`)}
      </Button>
    )}

    {event.can_pay_now && (
      <CustomNextButton
        dataTestId={`billing-information-step-${isFixed ? 'next' : 'pay-now'}`}
        onClick={() => {
          payWhen.current = PayWhen.PAY_NOW;
          submitForm();
        }}
        isLoading={payWhen.current === PayWhen.PAY_NOW && isSubmitting}
        $isFixed={isFixed}
        $breakpoint={breakpoint}
      >
        {isFixed ? s__(`NetworkEvents|Next`) : s__(`NetworkEvents|Pay now`)}
      </CustomNextButton>
    )}
  </WrapperButtonPay>
);

export default PayButtons;

const WrapperButtonPay = styled(Box)`
  flex-direction: ${({ $isFixed, $breakpoint }) =>
    $isFixed && $breakpoint === 's' && 'column-reverse'};
`;

const CustomNextButton = styled(Button)`
  margin-bottom: ${({ $isFixed, $breakpoint }) =>
    $isFixed && $breakpoint === 's' && '12px'};
  max-width: ${({ $isFixed }) => $isFixed && '133px'};
`;
